import { gql } from "apollo-boost";
import { apolloClient, getApolloOptions } from "./apolloClient";

const GET_BOOKING = gql`
  query Booking($id: ID!) {
    booking(id: $id) {
      id
      code
      demo
      consent_to_share
      door_code
      deleted_at
      refund_requested
      finished
      voucher_requested
      end_of_game_mail_sent
      xcube {
        id
        name
        location {
          id
          time_zone
          name
          booking_system
        }
      }
      team {
        id
        name
      }
      player_count
      language
      rating
      experience {
        id
        name
        duration
      }
      score
      date
      rating
      rating_location
      results
      minutes_played
      client {
        id
        first_name
        last_name
        email
        zip_code
        place_name
        country
        phone_number
      }
      photos {
        id
        url
        size
        previewUrl
      }
    }
  }
`;


export const fetchBookingData = async (id) => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_BOOKING,
        variables: { id },
    });
    return res.data.booking;
};
